import { render, staticRenderFns } from "./SecureHome.vue?vue&type=template&id=36215a56&"
import script from "./SecureHome.vue?vue&type=script&lang=js&"
export * from "./SecureHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports